<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="0">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-tooltip v-if="person.user && (current_user.slug == 'employee' || current_user.slug == 'distributor')">
                                <template slot="activator">
                                    <v-btn icon @click="openFiltersPermissionsDialog()">
                                        <v-icon>security</v-icon>
                                    </v-btn>
                                </template>
                                {{ `Permissions` }}
                            </bc-tooltip>
                            <bc-btn-add @invoke-method="invokeMethod($event)" :add-list="addList" perm="people.update"></bc-btn-add>
                            <bc-tooltip
                                v-if="
                                    hasPerm('users.login_as') &&
                                    checkLoggedInAsOtherUser &&
                                    selectedPerson.user != null &&
                                    current_user.user_id != person.user.user_id
                                "
                            >
                                <template slot="activator">
                                    <v-btn icon @click="loginAsSelectedUser()">
                                        <v-icon>login</v-icon>
                                    </v-btn>
                                </template>
                                {{ `Login as User` }}
                            </bc-tooltip>
                            <bc-btn-refresh @invoke-method="dbGetPerson()"></bc-btn-refresh>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobileList"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <v-container grid-list-xl v-if="people != null">
                    <v-layout row :wrap="$bp.smallScreen">
                        <v-flex xs12 md4 lg3 align-self-start pb-0 :pl-0="!$bp.smallScreen">
                            <v-layout row wrap>
                                <v-flex xs8 py-0>
                                    <bc-tooltip v-if="person.has_user_account == 'Yes'" right>
                                        <template slot="activator">
                                            <v-btn
                                                v-if="hasPerm('people.update')"
                                                style="max-width: 120px; text-transform: none"
                                                class="pl-1"
                                                round
                                                selected
                                                :color="person.status_class"
                                                text-color="white"
                                                @mouseup.left="dbChangedStatus()"
                                            >
                                                <v-icon color="white" class="mr-2" v-model="person.user.status">{{
                                                    status_loader ? "fas fa-circle-notch fa-spin" : "check_circle"
                                                }}</v-icon>
                                                <span class="white--text">{{
                                                    people && person.login_type ? $t(`lang.${person.login_type}`) : $t("lang.loading")
                                                }}</span>
                                            </v-btn>
                                            <v-chip
                                                v-else
                                                disabled
                                                round
                                                text-color="white"
                                                class="chip-padding-left-4 mr-auto fs-14"
                                                :color="person.status_class"
                                            >
                                                <span><v-icon class="mr-2">check_circle</v-icon></span>
                                                <span class="white--text">{{ $t(`lang.${person.login_type}`) }}</span>
                                            </v-chip>
                                        </template>
                                        {{ person.user.status == 0 ? $t("lang.click_to_activate") : $t("lang.click_to_deactivate") }}
                                    </bc-tooltip>
                                    <bc-btn-add
                                        v-else
                                        @invoke-method="invokeMethod($event)"
                                        action="openNewUserDialog"
                                        :tooltip="$t('lang.activate_user_account')"
                                        right
                                        permanent
                                        perm="users.create"
                                    ></bc-btn-add>
                                </v-flex>
                                <v-flex xs4 pr-0 py-0>
                                    <bc-tooltip class="ml-auto" perm="people.update">
                                        <template slot="activator">
                                            <v-btn @click="openPeopleProfileDialog()" icon>
                                                <v-icon color="indigo">edit</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t("lang.modify_person") }}
                                    </bc-tooltip>
                                </v-flex>
                                <v-flex xs12 py-0 v-if="hasPerm('people.update')">
                                    <bc-tooltip top>
                                        <template slot="activator">
                                            <v-img
                                                :src="showErrorImg ? errorImg : person.photo"
                                                height="150px"
                                                width="150px"
                                                class="rounded-circle mx-auto clickable"
                                                @mouseup.left="$refs.croppa.chooseFile()"
                                                :key="updatePhoto"
                                                @error="showErrorImg = true"
                                            ></v-img>
                                        </template>
                                        {{ $t("lang.uploadImage") }}
                                    </bc-tooltip>
                                </v-flex>
                                <v-flex class="py-1" @mouseup.left="hasPerm('people.update') ? openPeopleProfileDialog() : ''">
                                    <p class="display-1 mb-0 text-xs-center">{{ person.combined_name }}</p>
                                    <p class="display-0 mb-0 text-xs-center">{{ person.job_title }}</p>
                                </v-flex>
                            </v-layout>
                            <v-divider v-if="person.entity_phones" class="my-0"></v-divider>
                            <bc-list
                                v-if="person.entity_phones"
                                :items="person.entity_phones"
                                prepend-icon="phone"
                                perm="people.update"
                                @invoke-method="showPhone($event)"
                            >
                                <template slot-scope="data">
                                    <v-flex>{{ data.item.phone_number_formatted ? data.item.phone_number_formatted : data.item.phone_number }}</v-flex>
                                    <v-flex list-sub>{{ $t(`lang.${data.item.phone_type}`) }}</v-flex>
                                </template>
                            </bc-list>
                            <v-divider v-if="person.entity_emails" class="my-0"></v-divider>
                            <bc-list
                                v-if="person.entity_emails"
                                :items="person.entity_emails"
                                prepend-icon="email"
                                perm="people.update"
                                @invoke-method="showEmail($event)"
                            >
                                <template slot-scope="data">
                                    <v-flex>{{ data.item.email_address }}</v-flex>
                                    <v-flex list-sub>{{ $t(`lang.${data.item.email_type}`) }}</v-flex>
                                </template>
                            </bc-list>
                            <v-divider v-if="person.entity_addresses" class="my-0"></v-divider>
                            <bc-list
                                v-if="person.entity_addresses"
                                :items="person.entity_addresses"
                                prepend-icon="location_on"
                                perm="people.update"
                                @invoke-method="showAddress($event)"
                            >
                                <template slot-scope="data">
                                    <v-flex>{{ data.item.address1 }}</v-flex>
                                    <v-flex list-sub>{{ `${data.item.city}, ${data.item.state} ${data.item.zip_code}` }}</v-flex>
                                    <v-flex list-sub>{{ $t(`lang.${data.item.address_type}`) }}</v-flex>
                                </template>
                            </bc-list>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="info" perm="people.update" @invoke-method="openPeopleProfileDialog()">
                                <template>
                                    <v-flex d-inline xs12 mt-1
                                        >{{ `${$t("lang.user_time_zone")}:` }} <span class="fw-semi-bold">{{ person.user_time_zone || "---" }}</span></v-flex
                                    >
                                    <v-flex d-inline xs12 mt-1
                                        >{{ `${$t("lang.unit_of_measure")}:` }}
                                        <span class="fw-semi-bold">{{
                                            (person.unit_of_measure_display ? person.unit_of_measure_display : "---") | capitalize
                                        }}</span></v-flex
                                    >
                                    <v-flex d-inline xs12 mt-1
                                        >{{ `${$t("lang.language")}:` }}
                                        <span class="fw-semi-bold">{{ (person.directory ? person.directory : "---") | capitalize }}</span></v-flex
                                    >
                                </template>
                            </bc-list>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs12 md8 lg9 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                            <div>
                                <v-card elevation="0" :key="refresh">
                                    <keep-alive>
                                        <component
                                            ref="peopleComponents"
                                            is="notifications"
                                            :person="selectedPerson"
                                            :has-perms="allow_people_update"
                                            class="tab"
                                        ></component>
                                    </keep-alive>
                                </v-card>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-container>
        <bc-dialog :value="addTokenDialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.addToken") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="addTokenDialog"
                        :dialog-status="addTokenDialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="addTokenFormValidation">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        :focus="addTokenDialog"
                                        v-model="newToken.user_id"
                                        :label="$t('lang.user_to_give_token')"
                                        :items="peopleForToken"
                                        item-value="people_id"
                                        item-text="combined_name"
                                        :rules="ifValid($r.required(true))"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-model="newToken.company_id"
                                        :label="$t('lang.company')"
                                        :items="userCompanies"
                                        item-value="company_id"
                                        item-text="company"
                                        :rules="ifValid($r.required(true))"
                                    ></bc-autocomplete>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="addTokenDialog = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="createToken()">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-dialog :value="person_dialog" max-width="700">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.modify_person") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="person_dialog"
                        :dialog-status="person_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="formPerson">
                        <v-container pa-0 grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-focus="person_dialog"
                                        v-model="person.first_name"
                                        :label="`${$t('lang.first_name')} *`"
                                        :counter="showCounter(person.first_name, 'person.first_name')"
                                        :rules="ifValid('people.first_name')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-model="person.last_name"
                                        :label="`${$t('lang.last_name')} *`"
                                        :counter="showCounter(person.last_name, 'person.last_name')"
                                        :rules="ifValid('people.last_name')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-model="person.nick_name"
                                        :label="$t('lang.nick_name')"
                                        :counter="showCounter(person.nick_name, 'person.nick_name')"
                                        :rules="ifValid('people.nick_name')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-model="person.job_title"
                                        :label="`${$t('lang.job_title')}`"
                                        :counter="showCounter(person.job_title, 'person.job_title')"
                                        :rules="ifValid('people.job_title')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <bc-autocomplete
                                        v-model="person.user_time_zone"
                                        :label="`${$t('lang.user_time_zone')} *`"
                                        :items="timeZones"
                                        item-value="value"
                                        item-text="text"
                                        :rules="ifValid('people.user_time_zone')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <bc-select
                                        v-model="person.unit_of_measure"
                                        :label="`${$t('lang.unit_of_measure')} *`"
                                        :items="unitOfMeasure"
                                        :rules="ifValid('people.unit_of_measure')"
                                    ></bc-select>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <bc-autocomplete
                                        v-model="person.language"
                                        :label="`${$t('lang.language')}`"
                                        :items="active_languages"
                                        item-value="iso"
                                        item-text="language"
                                        :rules="ifValid('people.language')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6 v-if="person.user">
                                    <v-text-field
                                        v-model="person.user.username"
                                        :label="`${$t('lang.username')} *`"
                                        :counter="showCounter(person.user.username, 'user.username')"
                                        :rules="ifValid('user.username')"
                                        @change="dbcheckUserNameAvail(person.user.username)"
                                    >
                                        <template slot="append-outer">
                                            <bc-tooltip>
                                                <template slot="activator">
                                                    <v-icon
                                                        :color="
                                                            (!person.username || person.username != person.user.username) && availableUserName.exists
                                                                ? 'error'
                                                                : 'success'
                                                        "
                                                    >
                                                        {{
                                                            (!person.username || person.username != person.user.username) && availableUserName.exists
                                                                ? "close"
                                                                : "check"
                                                        }}
                                                    </v-icon>
                                                </template>
                                                {{
                                                    person.username
                                                        ? person.username != person.user.username && availableUserName.exists
                                                            ? $t("lang.username_not_avail")
                                                            : $t("lang.username_avail")
                                                        : $t("lang.username_not_set")
                                                }}
                                            </bc-tooltip>
                                        </template>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 v-if="person.user && hasPerm('users.update')">
                                    <bc-autocomplete
                                        v-model="person.entity_emails_id"
                                        :label="$t('lang.email_address_notification')"
                                        :items="person.entity_emails || []"
                                        item-value="entity_emails_id"
                                        item-text="email_address"
                                        clearable
                                        :rules="ifValid('people.entity_emails_id')"
                                        @click:clear="
                                            $nextTick(() => {
                                                person.entity_emails_id = '';
                                            })
                                        "
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6 v-if="person.user && hasPerm('users.update')">
                                    <bc-autocomplete
                                        v-model="person.entity_phones_id"
                                        :label="$t('lang.mobile_phone_notification')"
                                        :items="person.entity_phones || []"
                                        item-value="entity_phones_id"
                                        item-text="phone_number"
                                        clearable
                                        :rules="ifValid('people.entity_phones_id')"
                                        @click:clear="
                                            $nextTick(() => {
                                                person.entity_phones_id = '';
                                            })
                                        "
                                    >
                                        <template slot="item" slot-scope="data">
                                            {{ data.item.phone_number_formatted ? data.item.phone_number_formatted : data.item.phone_number }}
                                        </template>
                                        <template slot="selection" slot-scope="data">
                                            {{ data.item.phone_number_formatted ? data.item.phone_number_formatted : data.item.phone_number }}
                                        </template>
                                    </bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6 v-if="hasPerm('users.update') && person.has_user_account == 'Yes'">
                                    <bc-autocomplete
                                        v-model="person.user.login_type_id"
                                        :label="`${$t('lang.login_type')} *`"
                                        :items="login_types"
                                        item-value="login_type_id"
                                        item-text="login_type"
                                        :rules="ifValid('user.login_type_id')"
                                    >
                                        <template slot="item" slot-scope="data">
                                            {{ $t(`lang.${data.item.login_type}`) }}
                                        </template>
                                        <template slot="selection" slot-scope="data">
                                            {{ $t(`lang.${data.item.login_type}`) }}
                                        </template>
                                    </bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6 v-if="hasPerm('users.update') && person.has_user_account == 'Yes'">
                                    <v-switch
                                        v-model="person.user.restrict_login_location"
                                        :label="$t('lang.restrict_login_location')"
                                        true-value="1"
                                        false-value="0"
                                    >
                                        <template slot="label">
                                            <span>{{ $t("lang.restrict_login_location") + ":&nbsp;" }}</span
                                            ><span class="fw-bold">{{ person.user.restrict_login_location == "1" ? "Yes" : "No" }}</span>
                                        </template>
                                    </v-switch>
                                </v-flex>
                                <v-flex
                                    xs12
                                    sm6
                                    v-if="
                                        hasPerm('people.update') &&
                                        selectedPerson.user != null &&
                                        person.user.login_type_id != null &&
                                        person.user.login_type_id == 2
                                    "
                                >
                                    <bc-autocomplete
                                        v-model="person.user.department_id"
                                        :label="$t('lang.department_name')"
                                        :items="department_options"
                                        item-value="department_id"
                                        item-text="department_name"
                                        :rules="ifValid($r.required(true))"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 v-if="hasPerm('people.update') && person.user.login_type_id == 1">
                                    <v-checkbox
                                        v-model="person.user.is_supervisor"
                                        true-value="1"
                                        false-value="0"
                                        label="Is a Supervisor"
                                        :rules="ifValid('user.is_supervisor')"
                                    ></v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-menu
                        top
                        right
                        class="hidden-sm-and-up"
                        content-class="no-stripe"
                        v-if="person.slug == 'employee' && person.user && hasPerm('users.update')"
                    >
                        <v-btn color="secondary" slot="activator">
                            <v-icon>keyboard_arrow_up</v-icon>
                            {{ $t("lang.more") }}
                        </v-btn>
                        <v-list>
                            <v-list-tile v-for="item in modify_list" :key="item.title" @click="invokeMethod(item)">
                                <v-list-tile-title>
                                    {{ item.title }}
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <template v-if="$bp.smAndUp && hasPerm('users.update') && person.user">
                        <v-btn @mouseup.left="openChangePassword()" color="primary">
                            {{ $t("lang.change_password") }}
                        </v-btn>
                        <v-btn @mouseup.left="$refs.scan_barcode.openBarcode()" color="primary" :outline="person.has_qr_code == '0'">
                            {{ person.has_qr_code == "1" ? "Change QR" : "Enable QR" }}
                        </v-btn>
                        <v-btn @mouseup.left="openRFID()" color="primary" :outline="person.has_rfid == '0'">
                            {{ person.has_rfid == "1" ? "Change RFID" : "Enable RFID" }}
                        </v-btn>
                    </template>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="person_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="savePeople()">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-scan-barcode
            ref="scan_barcode"
            scan-object="user_qr_code"
            header-text="Scan QR Code"
            scan-text="Scan"
            @scanned="submit_qr($event)"
            :no-button="true"
        >
            <template slot="delete-button">
                <v-btn v-if="person.has_qr_code == '1'" color="error" @mouseup.left="$refs.delete_qr_code.openDialog()">{{ $t("lang.delete") }}</v-btn>
            </template>
        </bc-scan-barcode>
        <bc-dialog :value="rfid_dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">Enable RFID Login</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close @invoke-method="invokeMethod($event)" action="closeRFID" :dialog-status="rfid_dialog"></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-form>
                        <v-layout row wrap class="black--text">
                            <v-flex xs12 mx-auto>
                                <v-layout row mx-auto>
                                    <v-flex :class="$bp.smallScreen ? 'display-2' : 'display-3'">
                                        {{ rfid_loader ? "Loading" : "Scan Card" }}
                                    </v-flex>
                                    <v-flex mt-auto ml-4 :class="[$bp.smallScreen ? 'mb-2' : 'mb-3']">
                                        <div class="animation" :class="rfid_loader ? 'dot-falling' : 'dot-typing'"></div>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12>
                                <v-icon class="display-4" style="font-family: Material Icons !important">payment</v-icon>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="person.has_rfid == '1'" color="error" @mouseup.left="openDeleteRFID()">{{ $t("lang.delete") }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeRFID()">{{ $t("lang.cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <delete-confirmation-dialog
            ref="delete_qr_code"
            :heading="$t('lang.delete_qr_code')"
            :message="$t('lang.confirm_delete_message')"
            @onConfirm="submit_qr('DELETE')"
        ></delete-confirmation-dialog>

        <delete-confirmation-dialog
            ref="delete_rfid"
            :heading="$t('lang.delete_rfid')"
            :message="$t('lang.confirm_delete_message')"
            @onConfirm="submit_rfid('DELETE')"
            @close="activateRFID()"
        ></delete-confirmation-dialog>

        <bc-dialog :value="user_dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.activate_user_account") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close @invoke-method="invokeMethod($event)" action="closeNewUserDialog" :dialog-status="user_dialog"></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="user">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="user.username"
                                        :label="`${$t('lang.username')} *`"
                                        :counter="showCounter(user.username, 'user.username')"
                                        :rules="availableUserName.exists ? [`${$t('lang.not_available')}`] : ifValid('user.username')"
                                        @change="dbcheckUserNameAvail(user.username)"
                                    >
                                        <template slot="append-outer">
                                            <bc-tooltip>
                                                <template slot="activator">
                                                    <v-icon :color="availableUserName.exists ? 'error' : 'success'">{{
                                                        availableUserName.exists ? "close" : "check"
                                                    }}</v-icon>
                                                </template>
                                                {{ availableUserName.exists ? $t("lang.username_not_avail") : $t("lang.username_avail") }}
                                            </bc-tooltip>
                                        </template>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-password-input
                                        v-model="user.password"
                                        :label="`${$t('lang.password')} *`"
                                        :counter="showCounter(user.password, 'user.password')"
                                        :rules="ifValid('user.password')"
                                    ></bc-password-input>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-password-input
                                        v-model="confirm_password_user"
                                        :label="`${$t('lang.confirm_password')} *`"
                                        :rules="ifValid('user.confirm_password')"
                                    ></bc-password-input>
                                </v-flex>
                                <v-flex xs12 v-if="currUserField('slug') == 'employee'">
                                    <bc-autocomplete
                                        v-model="user.login_type_id"
                                        :label="`${$t('lang.login_type_id')} *`"
                                        :items="login_types"
                                        item-value="login_type_id"
                                        item-text="login_type"
                                        :rules="ifValid('user.login_type_id')"
                                    >
                                        <template slot="item" slot-scope="data">
                                            {{ $t(`lang.${data.item.login_type}`) }}
                                        </template>
                                        <template slot="selection" slot-scope="data">
                                            {{ $t(`lang.${data.item.login_type}`) }}
                                        </template>
                                    </bc-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-model="user.department_id"
                                        :label="$t('lang.department_name')"
                                        :items="department_options"
                                        item-value="department_id"
                                        item-text="department_name"
                                        :rules="ifValid($r.required(true))"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-if="user.login_type_id != '1'"
                                        v-model="user.company_id"
                                        :label="`${$t('lang.company_id')} *`"
                                        :items="companies"
                                        item-text="company"
                                        item-value="company_id"
                                        :rules="ifValid('user.company_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                    <v-switch
                                        v-model="user.owner"
                                        :label="user.owner == '1' ? $t('lang.is_owner_yes') : $t('lang.is_owner_no')"
                                        true-value="1"
                                        false-value="0"
                                        ripple
                                    ></v-switch>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeNewUserDialog()">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="addUser()">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>

        <bc-dialog :value="update_password_dialog">
            <v-card>
                <v-card-title class="red-dialog-title">
                    <span class="headline">{{ $t("lang.change_password") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="update_password_dialog"
                        :dialog-status="update_password_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="update_password">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <bc-password-input
                                        v-model="update_password.password"
                                        :label="`${$t('lang.password')} *`"
                                        :counter="showCounter(update_password.password, 'update_password.password')"
                                        :rules="ifValid('update_password.password')"
                                    ></bc-password-input>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-password-input
                                        v-model="confirm_password"
                                        :label="`${$t('lang.confirm_password')} *`"
                                        :counter="showCounter(confirm_password, 'update_password.confirm_password')"
                                        :rules="ifValid('update_password.confirm_password')"
                                    ></bc-password-input>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="update_password_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="changePassword()">{{ $t("lang.update") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-file-upload ref="croppa" :upload-function="handleFileUpload"></bc-file-upload>
        <bc-phone-dialog
            ref="phoneDialog"
            object_ref="people"
            :object_id="$route.params.id"
            :total_items="person.entity_phones || []"
            :scope="person.scope"
            @eventname="updatePhones"
        ></bc-phone-dialog>
        <bc-address-dialog
            ref="addressDialog"
            object_ref="people"
            :object_id="$route.params.id"
            :total_items="person.entity_addresses || []"
            :scope="person.scope"
            @eventname="updateAddresses"
        ></bc-address-dialog>
        <bc-email-dialog
            ref="emailDialog"
            :getFunction="getPerson"
            entity_object="people"
            :entity_id="people_id"
            :total_items="entity_emails || []"
            :scope="person.scope"
        ></bc-email-dialog>
        <bc-dialog :value="filtersPermissionsDialog" fullscreen>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.permissions") }}</span>
                    <v-spacer></v-spacer>
                    <!-- <bc-btn-refresh @invoke-method=""></bc-btn-refresh> -->
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="filtersPermissionsDialog"
                        :dialog-status="filtersPermissionsDialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-container fluid grid-list-form>
                        <v-layout row wrap>
                            <v-flex xs12 v-if="current_user.slug != 'distributor'">
                                <app-card
                                    headerIcon="lock"
                                    :heading="$t('lang.permissions')"
                                    colClasses=""
                                    customClasses="mb-0"
                                    :fullScreen="true"
                                    :closeable="true"
                                    :fullBlock="true"
                                    :footer="true"
                                >
                                    <keep-alive
                                        ><component
                                            v-if="filtersPermissionsDialog"
                                            ref="peopleComponents"
                                            is="user_permissions"
                                            :person="returnPerson"
                                            :has-perms="allow_people_update"
                                        ></component
                                    ></keep-alive>
                                    <v-spacer slot="footer"></v-spacer>
                                    <v-btn
                                        class="mr-2"
                                        slot="footer"
                                        color="success"
                                        @click="sendUpdatePermissionsCmd()"
                                        :disabled="!permissions_changed"
                                        depressed
                                    >
                                        {{ $t("lang.save") }}&nbsp;&nbsp;<v-icon color="white">save</v-icon>
                                    </v-btn>
                                    <v-btn slot="footer" depressed color="error" @click="sendUndoPermissionsCmd()" :disabled="!permissions_changed">
                                        {{ $t("lang.undo_changes") }}&nbsp;&nbsp;<v-icon color="white">replay</v-icon>
                                    </v-btn>
                                </app-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </bc-dialog>
    </div>
</template>

<script>
import people_user_tokens from "Core/people/components/UserTokens";
import ScanQrCode from "Components/Header/ScanQrCode";
import { store } from "Store/store";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import AppConfig from "Constants/AppConfig";
import user_permissions from "Core/users/views/UserPermissions";
import notifications from "Modules/people/components/Notifications";

import { peopleProfileComponents } from "Modules/people/components/profile.data.js";

export default {
    data() {
        return {
            allow_people_update: true,
            peopleForToken: null,
            newToken: {
                user_id: null,
                company_id: null,
            },
            subComponentsMap: {},
            subComponents: peopleProfileComponents,
            selectedComponent: "notifications",
            component: null,
            enable_search: true,
            user: {
                username: "",
                password: "",
                company_id: "",
                login_type_id: "",
                is_supervisor: false,
            },
            confirm_password_user: "",
            has_user_account: "No",
            update_password: {
                user_id: "",
                password: "",
            },
            confirm_password: "",
            person_dialog: false,
            user_dialog: false,
            update_password_dialog: false,
            companies: null,
            userCompanies: null,
            user_account: false,
            qr_code: null,
            rfid_value: null,
            rfid_dialog: false,
            rfid_timer: "",
            rfid_loader: false,
            editStatus: {
                users: {
                    user_id: "",
                    status: "",
                },
            },
            status_loader: false,
            addTokenDialog: false,
            dbChangedStatus: _.debounce(this.changeStatus, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbGetPerson: _.debounce(this.getPerson, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbcheckUserNameAvail: _.debounce(this.checkUserNameAvail, 1500, { maxWait: 1500, leading: true, trailing: false }),
            availableUserName: {
                exists: true,
            },
            unitOfMeasure: [
                { value: "0", text: this.$t("lang.imperial") },
                { value: "1", text: this.$t("lang.metric") },
            ],
            newFile: {
                photo_file: "",
            },
            updatePhoto: 0,
            people_id: 0,
            person: {
                user: {},
            },
            refresh: 0,
            timeZones: null,
            errorImg: AppConfig.defaultProfilePhoto,
            hasCam: !$cookies.isKey("bc-no-cam"),
            showErrorImg: false,
            addList: [
                { title: this.$t("lang.addNumber"), action: "showPhone", ref: "phoneDialog", icon: "phone" },
                { title: this.$t("lang.addEmail"), action: "showEmail", ref: "emailDialog", icon: "email" },
                { title: this.$t("lang.addAddress"), action: "showAddress", ref: "addressDialog", icon: "location_on" },
                // { title: this.$t('lang.addToken'), action: "openTokenDialog", icon: "generating_tokens" },
            ],
            mobileList: [
                { title: this.$t("lang.addNumber"), action: "showPhone", ref: "phoneDialog", perms: ["people.update"] },
                { title: this.$t("lang.addEmail"), action: "showEmail", ref: "emailDialog", perms: ["people.update"] },
                { title: this.$t("lang.addAddress"), action: "showAddress", ref: "addressDialog", perms: ["people.update"] },
                // { title: this.$t('lang.addToken'), action: "openTokenDialog"},
                { title: this.$t("lang.refresh"), action: "dbGetPerson" },
            ],
            filtersPermissionsDialog: false,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchPerson", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.person) {
                        localStorage.setItem("current_person", JSON.stringify(data.person));
                        this.person = this.assignObj2(JSON.parse(localStorage.getItem("current_person")), this.rules_people);
                        localStorage.removeItem("current_person");
                        this.refresh2();
                        this.finishLoader();
                        this.getUser();
                        next();
                    } else {
                        next({ name: "people", replace: true });
                    }
                });
        } else {
            this.refresh2();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchPerson", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.person) {
                        next((vm) => {
                            localStorage.setItem("current_person", JSON.stringify(data.person));
                            vm.person = vm.assignObj2(JSON.parse(localStorage.getItem("current_person")), vm.rules_people);
                            localStorage.removeItem("current_person");
                            vm.refresh2();
                            vm.finishLoader();
                            vm.getUser();
                        });
                    } else {
                        next({ name: "people", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh2();
                vm.finishLoader();
            });
        }
    },
    computed: {
        ...mapState({
            rules_people: (state) => state.people.rules_people,
            person_status_options: (state) => state.settings.person_status_options,
            people: (state) => state.people.people,
            selectedPerson: (state) => state.people.selectedPerson,

            rules_update_password: (state) => state.validation.rules_update_password,
            rules_user: (state) => state.validation.rules_user,
            entity_addresses: (state) => state.people.entity_addresses,
            entity_phones: (state) => state.people.entity_phones,
            entity_emails: (state) => state.people.entity_emails,
            active_languages: (state) => state.languages.active_languages,
            department_options: (state) => state.departments.department_options,
            customer_options: (state) => state.customers.customer_options,
            vendor_options: (state) => state.vendors.vendor_options,
            company_options: (state) => state.companies.company_options,
        }),
        ...mapGetters(["login_types", "permissions_changed"]),
        returnPerson() {
            return this.selectedPerson;
        },
        returnTabs() {
            let tabs = [{ title: "notifications", name: "notifications", slug: ["employee", "customer"] }];
            if (this.person.user_id != null) {
                tabs.push({ title: "permissions", name: "permissions", slug: ["employee"], perms: ["permissions.read"] });
            }

            return tabs.filter((tab) => {
                return this.current_user ? tab.slug.indexOf(this.current_user.slug) >= 0 : false;
            });
        },
        modify_list() {
            let modifylist = [
                { title: this.$t("lang.change_password"), action: "openChangePassword" },
                { title: this.person.has_rfid == "1" ? "Change RFID" : "Enable RFID", action: "openRFID" },
                { title: this.person.has_qr_code == "1" ? "Change QR" : "Enable QR", action: "openBarcode", ref: "scan_barcode" },
            ];

            return modifylist;
        },
        checkLoggedInAsOtherUser() {
            return localStorage.getItem("original_current_user") === null ? true : false;
        },
    },
    methods: {
        ...mapActions([
            "fetchPerson",
            "savePerson",
            "deletePerson",
            "printPerson",
            "fetchDepartments",
            "fetchCustomers",
            "fetchVendors",
            "fetchCompanies",
            "loginAsUser",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        registerComponents() {
            this.subComponents.forEach((cData) => {
                cData.import().then((component) => {
                    if (cData.name == "permissions" && this.person.user_id == null) {
                    } else {
                        this.$set(this.subComponentsMap, cData.name, component.default);
                    }
                });
            });
        },
        selectComponent(componentName) {
            this.component = this.subComponentsMap[componentName];
        },
        getPerson(pg_refresh = false) {
            this.startLoader();

            this.fetchPerson({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.person) {
                    this.person = this.assignObj2(data.person, this.rules_people);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        savePeople() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formPerson")) {
                    let body = this.prepForm(this.person, this.rules_people);
                    if (this.person.user) {
                        body["users"] = this.prepForm(this.person.user, this.rules_user);
                        body["users"]["user_id"] = this.person.user.user_id;
                        delete body["users"].owner;
                    }

                    this.savePerson({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.person) {
                            this.person = this.assignObj2(data.person, this.rules_people);
                            this.validationOff();
                            this.customer_dialog = false;
                        }
                        this.toggleModalLoader(false);
                    });
                }
            });
        },
        changeStatus() {
            this.status_loader = true;
            let status = this.person.user.status == 1 ? 0 : 1;
            let body = { people_id: `${this.$route.params.id}`, users: { user_id: this.person.user.user_id, status: status } };

            this.savePerson({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.person) {
                    this.person = this.assignObj2(data.person, this.rules_people);
                    this.status_loader = false;
                    this.finishLoader();
                }
            });
        },
        async openCompanyModal() {
            this.people_dialog = true;
            this.growText++;

            if (this.payment_terms.length == 0) await this.fetchPaymentTerms({ body: { options: 1 } });
        },
        updateAddresses(addresses) {
            this.person.entity_addresses = addresses;
        },
        updatePhones(phones) {
            this.person.entity_phones = phones;
        },
        showAddress(item) {
            if (item) this.$refs.addressDialog.showAddress(item);
        },
        showPhone(item) {
            if (item) this.$refs.phoneDialog.showPhone(item);
        },
        showEmail(item) {
            if (item) this.$refs.emailDialog.showEmail(item);
        },

        async refresh2(force = false) {
            this.startLoader();

            if (this.login_types == null) {
                this.$store.dispatch("fetchLoginType", {
                    url: "login_types/",
                    method: "get",
                    stateProperty: "login_types",
                    dataProperty: "app_login_types",
                    commit: true,
                    localStorage: true, //TODO: this can probably be taken out of localstorage
                });
            }
            if (this.timeZones == null) {
                this.$store
                    .dispatch("fetchLocale", {
                        url: "timezones/",
                        method: "get",
                        stateProperty: "time_zones",
                        commit: true,
                    })
                    .then((data) => {
                        if (typeof data !== "undefined") {
                            this.timeZones = data.time_zones;
                        }
                    });
            }
            if (this.active_languages == null) {
                this.$store.dispatch("fetchLanguages", {
                    url: "languages?status=1",
                    method: "get",
                    stateProperty: "active_languages",
                    dataProperty: "languages",
                    commit: true,
                });
            }

            if (this.department_options.length == 0 || force == true) await this.fetchDepartments({ body: { options: 1 } });

            this.registerComponents();

            this.finishLoader();
        },
        submit_qr(qr_code) {
            if (!!qr_code) {
                if (qr_code == "DELETE") this.$store.commit("toggleModalLoader", true);
                let person_body = {
                    users: {
                        user_id: this.person.user_id,
                        qr_code: qr_code == "DELETE" ? null : qr_code,
                    },
                };
                this.$store
                    .dispatch("fetchPeople", {
                        url: `people/${this.people_id}`,
                        method: "patch",
                        stateProperty: "person|entity_phones|entity_addresses|entity_emails",
                        dataProperty: "person|person.entity_phones|person.entity_addresses|person.entity_emails",
                        commit: true,
                        body: person_body,
                    })
                    .then((data) => {
                        if (data) {
                            this.$refs.scan_barcode.closeBarcode();
                            this.$store.commit("toggleModalLoader", false);
                        } else {
                            this.$refs.scan_barcode.resetBarcode(true);
                        }
                        this.$refs.delete_qr_code.close();
                    });
            }
        },
        submit_rfid(rfid_value) {
            if (!!rfid_value) {
                if (rfid_value == "DELETE") this.$store.commit("toggleModalLoader", true);
                let person_body = {
                    users: {
                        user_id: this.person.user_id,
                        rfid: rfid_value == "DELETE" ? null : rfid_value,
                    },
                };
                this.$store
                    .dispatch("fetchPeople", {
                        url: `people/${this.people_id}`,
                        method: "patch",
                        stateProperty: "person|entity_phones|entity_addresses|entity_emails",
                        dataProperty: "person|person.entity_phones|person.entity_addresses|person.entity_emails",
                        commit: true,
                        body: person_body,
                    })
                    .then((data) => {
                        if (data) {
                            this.rfid_dialog = false;
                            this.deactivateRFID();
                            if (rfid_value == "DELETE") this.$refs.delete_rfid.close(false);
                            setTimeout(() => {
                                this.rfid_loader = false;
                                this.$store.commit("toggleModalLoader", false);
                            }, 300);
                        } else {
                            this.rfid_loader = false;
                        }
                    });
            } else {
                this.activateRFID();
            }
        },
        openRFID() {
            this.rfid_dialog = true;
            this.activateRFID();
        },
        closeRFID() {
            this.rfid_dialog = false;
            this.deactivateRFID();
        },
        activateRFID() {
            this.rfid_value = "";
            window.addEventListener("keydown", this.checkKeydown);
        },
        deactivateRFID() {
            window.removeEventListener("keydown", this.checkKeydown);
            clearTimeout(this.rfid_timer);
            this.rfid_loader = false;
        },
        openDeleteRFID() {
            this.$refs.delete_rfid.openDialog();
            this.deactivateRFID();
        },
        // method to read in rfid input
        checkKeydown(e) {
            const key = e.key;
            if (key == "Enter") {
                this.submit_rfid(this.rfid_value);
                clearTimeout(this.rfid_timer);
            } else {
                if (!this.rfid_loader) {
                    this.rfid_loader = true;
                    this.rfid_timer = setTimeout(() => {
                        this.rfid_timer = null;
                        this.deactivateRFID();
                        this.$nextTick(() => {
                            this.activateRFID();
                            this.rfid_loader = false;
                            this.createAlert("error", "scan_again");
                        });
                    }, 5000); // 5 seconds
                }
                this.rfid_value += key;
            }
        },
        handleFileUpload(file) {
            let body = { people_id: `${this.$route.params.id}`, photo_file: file };
            this.toggleModalLoader(true);
            this.savePerson({
                body: body,
            })
                .then((data) => {
                    if (typeof data != "undefined" && data.person) {
                        this.person = this.assignObj2(data.person, this.rules_people);
                        this.status_loader = false;
                        this.finishLoader();
                    }
                })
                .finally(() => {
                    this.toggleModalLoader(false);
                    this.$root.$emit("escapePressed");
                    this.$nextTick(() => {
                        this.updatePhoto++;
                    });
                });
        },
        addUser() {
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("user")) {
                    this.user.people_id = this.person.people_id;
                    this.$store.commit("toggleModalLoader", true);
                    this.$store
                        .dispatch("fetchUsers", {
                            url: "users/",
                            method: "post",
                            body: this.user,
                        })
                        .then((data) => {
                            this.getPerson();
                            this.registerComponents();
                        })
                        .finally(() => {
                            this.$nextTick(() => {
                                this.$store.commit("validationOff");
                                this.$store.commit("toggleModalLoader", false);
                                this.user_dialog = false;
                            });
                        });
                }
            });
        },
        openPeopleProfileDialog() {
            this.person_dialog = true;
        },
        openNewUserDialog() {
            this.user_dialog = true;

            if (this.companies == null) {
                this.$store
                    .dispatch("fetchCustomers", {
                        url: "customers",
                        method: "get",
                    })
                    .then((data) => {
                        this.companies = data.customers;
                    });
            }
        },
        closeNewUserDialog() {
            this.user_dialog = false;
            this.user.owner = "0";
        },
        createToken() {
            console.log("test", "before validation turned on");
            this.$store.commit("validationOn", console.log("validation turned on"));
            console.log("test", "after validation turned on");
            this.$nextTick(() => {
                console.log("before addTokenFormValidation validated");
                if (this.$refs.addTokenFormValidation && this.validateForm("addTokenFormValidation")) {
                    console.log("validated form successfully");
                    this.$store.commit("toggleModalLoader", true);
                    setTimeout(() => {
                        console.log(this.newToken);
                    }, 3000);
                    this.$store.commit("toggleModalLoader", false);
                    this.addTokenDialog = false;
                } else {
                    console.log("Did not validate!");
                    this.$store.commit("toggleModalLoader", false);
                }
            });
        },
        openTokenDialog() {
            this.addTokenDialog = true;
            if (this.peopleForToken == null) {
                this.$store
                    .dispatch("fetchPeople", {
                        url: "people?has_user_account=1&page_size=100",
                        method: "get",
                    })
                    .then((data) => {
                        if (typeof data !== "undefined") {
                            this.peopleForToken = data.people;
                        }
                    });
            }
            if (this.userCompanies == null) {
                this.$store
                    .dispatch("fetchCustomers", {
                        url: "customers?user_id=" + this.person.user_id,
                        method: "get",
                    })
                    .then((data) => {
                        this.userCompanies = data.customers.filter((company) => {
                            return company.owner == 1;
                        });
                    });
            }
        },
        openChangePassword() {
            this.update_password_dialog = true;
        },
        changePassword() {
            this.status_loader = true;

            this.update_password.user_id = this.person.user_id;
            let body = { people_id: `${this.person.people_id}`, users: this.update_password };
            this.validationOn();
            this.savePerson({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.person) {
                    this.validationOff();
                    //this.person = this.assignObj2(data.person, this.rules_people);
                    this.update_password_dialog = false;
                }
            });
        },
        checkUserNameAvail(username) {
            let validateUserName = {
                username: username,
            };
            this.$store
                .dispatch("fetchUsers", {
                    url: "users/name_check",
                    method: "post",
                    body: {
                        username: username,
                    },
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.availableUserName.exists = data.users.exists;
                    }
                });
        },
        getUser() {
            if (this.person.user_id != null) {
                this.$store
                    .dispatch("fetchUsers", {
                        url: `users/${this.person.user_id}`,
                        method: "get",
                        headers: { "X-SILENT": "1" },
                    })
                    .then((data) => {
                        this.$store.commit("updateUserObject", data.user);
                    });
            }
        },
        loginAsSelectedUser() {
            this.loginAsUser({
                id: this.person.user.user_id,
            });
        },
        openFiltersPermissionsDialog(openDialog = true, fetch = true) {
            if (openDialog) this.filtersPermissionsDialog = true;
        },
        sendUpdatePermissionsCmd() {
            this.$store.commit("mutateUpdatePermissions", true);
        },
        sendUndoPermissionsCmd() {
            this.$store.commit("mutateUndoPermissions", true);
        },
    },
    components: {
        people_user_tokens,
        ScanQrCode,
        user_permissions,
        notifications,
    },
};
</script>
